<script>
/* global Mango */

import axios from 'axios';

import ModalConfirmCart from "./ModalConfirmCart.vue";
import priceFormatter from "../../../lib/priceFormatter";

const ERROR_REPORTER = window.ERROR_REPORTER
const MESSAGE_TYPE_ERROR = window.MESSAGE_TYPE_ERROR


export default {
    name: 'BaseMethods',
    methods: {
        isCartEmpty: function () {
            if (this.cart === null) {
                return true
            } else {
                return Object.keys(this.cart.ITEMS).length === 0
            }
        },
        formatPrice(price) {
            return priceFormatter.format(price)
        },
        checkBeforeOrder(successCallback) {
            const t = this;
            t.loader.cart++;
            t.busyNumbers = [];

            axios.request({
                method: 'post',
                url: t.domain + '/api/order/checkBefore/',
                params: {
                    isConfirmPage: t.isConfirmPage,
                    sessid: t.sessid,
                    backurl: location.href
                },
                responseType: 'json',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                    let data = response?.data?.data;

                    if (!data) {
                        ERROR_REPORTER.showMessage('Ошибка при проверке состава заказа', MESSAGE_TYPE_ERROR);
                        t.loader.cart--
                    } else if (response?.data?.status === 'success') {
                        t.loader.cart--;

                        if (typeof successCallback === 'function') {
                            successCallback();
                        }
                    }
                },
                function (error) {
                    let data = error?.response?.data?.data;

                    const message = data?.error_message ? data?.error_message : 'Ошибка при проверке состава заказа';

                    if (!data?.error_type) {
                        ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_ERROR);
                        return
                    }

                    let confirmParams = false;
                    switch (data.error_type) {
                        case 'busy_numbers':
                            axios.request({
                                method: 'post',
                                url: t.domain + '/ajax_new/cookieFunctions.php',
                                params: {
                                    sessid: t.sessid,
                                    action: 'set',
                                    name: data.error_type === 'external_error' ? 'ARR_EXTERNAL_ERROR' : 'ARR_BUSY_NUMBERS',
                                    value: encodeURIComponent(data.numbers),
                                    time: 3600
                                },
                                responseType: 'json',
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            });

                            t.errorItems = data.numbers;

                            if (data.error_type === 'busy_numbers') {
                                t.busyNumbers = data.numbers;
                            }

                            t.loader.cart--
                            ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_ERROR);
                            break;
                        case 'fmc_on_phis':
                            confirmParams = {
                                id: data.error_type,
                                body: message,
                                okTitle: 'Да',
                                cancelTitle: 'Нет',
                                confirmFunction: function () {
                                    axios.request({
                                        method: 'post',
                                        url: t.domain + '/ajax_new/deleteFMC.php',
                                        params: {
                                            sessid: t.sessid,
                                        },
                                        responseType: 'json',
                                        headers: {
                                            'X-Requested-With': 'XMLHttpRequest'
                                        }
                                    }).then(function () {
                                            t.reloadCart()
                                            t.loader.cart--;
                                        },
                                        function () {
                                            t.loader.cart--;
                                        }
                                    );
                                },
                                cancelFunction: function () {
                                    t.errorItems = data.error_product_id;
                                    t.loader.cart--;
                                }
                            }
                            break;
                        case 'mgp_not_select':
                            confirmParams = {
                                id: data.error_type,
                                body: message,
                                okTitle: 'Да',
                                cancelTitle: 'Нет',
                                confirmFunction: function () {
                                    let url = '/shop/tariffs/choose/?productId=' + data.anchor;
                                    url += (Mango.getUrlParameter('FRAME_LOAD') === 'Y') ? '&FRAME_LOAD=Y' : '';
                                    window.location.href = url;
                                },
                                cancelFunction: function () {
                                    t.loader.cart--
                                }
                            }
                            break;
                        case 'fmc_without_number':
                        case 'select_numbers':
                            confirmParams = {
                                id: data.error_type,
                                body: message,
                                okTitle: 'Да',
                                cancelTitle: 'Нет',
                                confirmFunction: function () {
                                    let url = '/shop/numbers/?productId=' + data.anchor;
                                    url += (Mango.getUrlParameter('FRAME_LOAD') === 'Y') ? '&FRAME_LOAD=Y' : '';
                                    window.location.href = url;
                                },
                                cancelFunction: function () {
                                    t.loader.cart--
                                }
                            }
                            break;
                        case 'number_without_vats':
                            confirmParams = {
                                id: data.error_type,
                                body: message,
                                okTitle: 'Да',
                                cancelTitle: 'Нет',
                                confirmFunction: function () {
                                    var url = '/shop/tariffs/vpbx/';
                                    url += (Mango.getUrlParameter('FRAME_LOAD') === 'Y') ? '?FRAME_LOAD=Y' : '';
                                    window.location.href = url;
                                },
                                cancelFunction: function () {
                                    t.loader.cart--
                                }
                            }
                            break;
                        case 'select_vats_list':
                            confirmParams = {
                                id: data.error_type,
                                body: message,
                                okTitle: 'Продолжить',
                                cancelTitle: 'Нет',
                                confirmFunction: function () {
                                    var selectCartVats = document.getElementById('js-select-cart-vats');
                                    if (!selectCartVats.value) {
                                        ERROR_REPORTER.showMessage('Выберите ВАТС', MESSAGE_TYPE_ERROR);
                                        return false;
                                    } else if (selectCartVats.value === 'new') {
                                        document.cookie = "select_vats_list=Y; path=/;";
                                        t.loader.cart--;
                                    } else {
                                        axios.request({
                                            method: 'post',
                                            url: t.domain + '/ajax_new/change_vats.php',
                                            params: {
                                                sessid: t.sessid,
                                                billingId_anchor: selectCartVats.value,
                                            },
                                            responseType: 'json',
                                            headers: {
                                                'X-Requested-With': 'XMLHttpRequest'
                                            }
                                        }).then(function () {
                                                document.cookie = "select_vats_list=Y; path=/;";
                                                t.reloadCart()
                                                t.loader.cart--;
                                            },
                                            function (error) {
                                                t.loader.cart--;

                                                if (
                                                    error?.response?.data?.status === 'error'
                                                    && error?.response?.data?.message.length > 0
                                                ) {
                                                    ERROR_REPORTER.showMessage(error.response.data.message, MESSAGE_TYPE_ERROR);
                                                }
                                            }
                                        );
                                    }
                                },
                                cancelFunction: function () {
                                    t.loader.cart--
                                }
                            }
                            break;
                        default:
                            ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_ERROR)
                            if (data.error_type === 'limits') {
                                t.errorItems = data.error_product_id;
                            }
                            t.loader.cart = false;
                    }

                    if (confirmParams !== false) {
                        if (t.$arcticModal['default'] === undefined) {
                            window.location.href = '/shop/cart/';
                        } else {
                            t.$arcticModal['default'].exposed.show(ModalConfirmCart,
                                confirmParams,
                                {
                                    name: data.error_type,
                                    adaptive: true,
                                    height: 'auto',
                                    clickToClose: false
                                }
                            );
                        }
                    }

                    t.loader.cart = false;
                }
            );
        },
    }
}
</script>